import React from 'react'
import { Redirect } from 'react-router-dom'

//Constants
import { authRequired } from '../utilities/guards'
import Routes from '../constants/routes'
import { getAllUserRoles, UserRoles } from '../constants/user-roles'
import userRoutes from './users-routes'

//Dashboard
import Dashboard from '../containers/Dashboard'

//Patient Health
import HealthReport from '../components/HealthReport'
import HealthConditions from '../components/HeathConditions'
import LabResults from '../components/LabResults'
import ClinicalNotes from '../components/ClinicalNotesGuest'
import MedicationAllergies from '../components/MedicationAllergies'
import Medications from '../components/Medications'
import PatientBookAppointment from '../containers/Appointments/PatientBookAppointment'
//Appointments
import AppointmentNew from '../components/AppointmentNew'

//Contact
import MessageCareTeam from '../components/MessageCareTeam'
import Contacts from '../components/Contacts'
import PatientInsurance from '../components/PatientInsurance'
import MainIndex from '../components/Consultation/MainIndex'

// Component to handle logout and redirect to signin
const LogoutAndRedirect = () => {
    React.useEffect(() => {
        localStorage.clear()
        window.location.href = Routes.SIGNIN
    }, [])
    return null
}

const meta = {
    auth: true,
    guards: [authRequired],
}

const authRoutes = [
    {
        path: [Routes.PATAIENTBOOKAPPOINTMENT, Routes.HOME],
        component: PatientBookAppointment,
        meta,
    },
    {
        path: Routes.SIGNIN,
        component: LogoutAndRedirect,
        meta: {
            auth: true,
            guards: [], // No guards needed, will clear session and redirect
        },
    },
    {
        path: '*',
        // eslint-disable-next-line react/display-name
        component: () => <Redirect to={Routes.PATAIENTBOOKAPPOINTMENT}></Redirect>,
        meta: {
            auth: true,
            guards: [], // No guards needed for redirect
        },
    },
]


export default authRoutes
